module.exports = __webpack_public_path__ + "img/hm_block03_02_sc.4a500b48.png";